import React, { useState } from "react";
import PrimaryButton from '../../components/Layout/PrimaryButton';
import MaskInput from '../../components/Layout/MaskInput';
import loaderIcon from '../../assets/loader.svg';
import './ModalRetention.scss';

import expensesService from '../../services/expenses';
import Utils from '../../components/Utils/Utils';

function ModalRetention({ onCloseModal, onSave, expenseID, initialValues }) {
  const [values, setValues] = useState({
    inss: initialValues?.inss || 0,
    issGramado: initialValues?.issGramado || 0,
    irrf: initialValues?.irrf || 0,
    csrf: initialValues?.csrf || 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleValueChange = (e, field) => {
    const parsed = parseFloat(String(e.formattedValue).replace(/[^\d,]/g, '').replace(',', '.'));
    setValues((prev) => ({
      ...prev,
      [field]: isNaN(parsed) ? 0 : parsed,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await expensesService.saveRetention(expenseID, values);
      onSave(expenseID, response.data);
    } catch (err) {
      console.error('Error saving retention:', err);
      setError('Algo deu errado! Tente novamente.');
      setLoading(false);
    }
  };

  return (
    <div className='modal-retention'>
      <div className="inner-content">
        <h1>Retenção</h1>
        <button className="btn-close" style={{border: '2px solid #fff', top: '-10px', right: '-10px' }} onClick={() => onCloseModal(true)}>X</button>
        {
          loading ? (
            <img className="loader" width={100} height={100} src={loaderIcon} alt="Carregando..." />
          ) : (
            <div className="wrapper-form">
              { error && <h2 className="error-message">{ error }</h2> }
              <label>
                INSS
                <MaskInput
                  type="amount"
                  defaultValue={Utils.currencyFormat(values.inss)}
                  placeholder={"R$ 0,00"}
                  onValueChange={(e) => handleValueChange(e, 'inss')}
                />
              </label>
              <label>
                ISS Gramado
                <MaskInput
                  type="amount"
                  defaultValue={Utils.currencyFormat(values.issGramado)}
                  placeholder={"R$ 0,00"}
                  onValueChange={(e) => handleValueChange(e, 'issGramado')}
                />
              </label>
              <label>
                IRRF
                <MaskInput
                  type="amount"
                  defaultValue={Utils.currencyFormat(values.irrf)}
                  placeholder={"R$ 0,00"}
                  onValueChange={(e) => handleValueChange(e, 'irrf')}
                />
              </label>
              <label>
                CSRF
                <MaskInput
                  type="amount"
                  defaultValue={Utils.currencyFormat(values.csrf)}
                  placeholder={"R$ 0,00"}
                  onValueChange={(e) => handleValueChange(e, 'csrf')}
                />
              </label>
              <PrimaryButton fullWidth onClick={handleSubmit}>Salvar</PrimaryButton>
            </div>
          )
        }
      </div>
    </div>
  );
}

export default ModalRetention;
